document.addEventListener("DOMContentLoaded", () => {

/* ============================================================
   🛑 HARD KILL SHOPIFY CART DRAWER (CORE API)
============================================================ 
(function() {

  // 1) Ubij globalni Shopify Drawer API
  if (window.Shopify && Shopify.CartDrawer) {
    Shopify.CartDrawer.prototype.open = function(){};
    Shopify.CartDrawer.prototype.renderContents = function(){};
  }

  // 2) Ubij svaki pokušaj otvaranja drawer-a preko event dispatcha
  const blockedEvents = [
    "shopify:section:load",
    "shopify:section:reorder",
    "shopify:section:select",
    "cart:updated",
    "cart:requestComplete"
  ];

  blockedEvents.forEach(evt => {
    document.addEventListener(evt, e => {
      e.stopImmediatePropagation();
    }, true);
  });

  // 3) Ubij DOM prikaz drawer-a
  const hideDrawer = () => {
    document.querySelectorAll("cart-drawer, .cart-drawer, #CartDrawer").forEach(el => {
      el.style.display = "none";
    });
  };

  hideDrawer();
  setInterval(hideDrawer, 200);

})();
*/


const isSFKProduct = window.location.pathname.includes("/products/saber-for-kids");

/* ============================================================
   🛒 CART REDIRECT – Saber for Kids custom cart (samo na product pageu)
============================================================ */

if (isSFKProduct) {
  // 1) Presretni SVE fetch pozive prema /cart/add(.js)
  const originalFetch = window.fetch ? window.fetch.bind(window) : null;

  if (originalFetch) {
    window.fetch = function (resource, config) {
      let url = "";

      if (typeof resource === "string") {
        url = resource;
      } else if (resource && typeof resource === "object" && "url" in resource) {
        url = resource.url;
      }

      const isAddToCart = url && url.indexOf("/cart/add") !== -1;

      if (!isAddToCart) {
        // Sve ostale fetch pozive pusti normalno
        return originalFetch(resource, config);
      }

      // Ovo je /cart/add(.js) → pusti da tema odradi svoje,
      // ali čim dobijemo OK, šaljemo usera na custom cart.
      return originalFetch(resource, config)
        .then((response) => {
          if (response.ok) {
            window.location.href = "/cart?view=saber-kids#force";
          }
          return response;
        })
        .catch((err) => {
          console.error("Intercepted /cart/add error:", err);
          // Ako nešto pukne, svejedno redirectamo na custom cart
          window.location.href = "/cart?view=saber-kids#force";
          throw err;
        });
    };
  }

  // 2) Safety-net: presretni SUBMIT na glavnom product formu
  //    (ako tema ipak radi full form submit, ne fetch)
  document.addEventListener(
    "submit",
    function (e) {
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;

      const action = form.getAttribute("action") || "";
      if (!action.includes("/cart/add")) return;

      // Ignoriraj submit unutar cart drawer-a / upsella
      if (
        form.closest("cart-drawer") ||
        form.closest("#CartDrawer") ||
        form.closest(".cart-drawer") ||
        form.closest("[data-is-cart-upsell='true']")
      ) {
        return;
      }

      e.preventDefault();
      e.stopPropagation();

      const formData = new FormData(form);

      (originalFetch || fetch)("/cart/add.js", {
        method: "POST",
        body: formData,
        headers: { Accept: "application/json" },
      })
        .then((res) => {
          if (!res.ok) throw new Error("Manual /cart/add failed");
          return res.json();
        })
        .then(() => {
          window.location.href = "/cart?view=saber-kids#force";
        })
        .catch((err) => {
          console.error("Manual /cart/add error:", err);
          window.location.href = "/cart?view=saber-kids#force";
        });
    },
    true // capture – ispred theme JS-a
  );
} // end if isSFKProduct


  // REMOVE ITEM (X button) – radi svugdje gdje postoji .remove-item
  document.addEventListener("click", function(e) {
    if (!e.target.classList.contains("remove-item")) return;

    const key = e.target.dataset.key;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
    .then(res => res.json())
    .then(() => location.reload());
  });


  /* ============================================================
     🛒 CART QUANTITY UPDATE
  ============================================================ */

  function updateCart(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(res => res.json())
      .then(() => location.reload());
  }

  // Delegation — hvata klikove čak i ako appovi mijenjaju DOM
  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".qty-btn");
    if (!btn) return;

    const key = btn.dataset.key;
    const input = document.querySelector(`.qty-input[data-key="${key}"]`);
    if (!input) return;

    let qty = parseInt(input.value || "0", 10);

    if (btn.classList.contains("plus")) qty++;
    if (btn.classList.contains("minus")) qty = Math.max(1, qty - 1);

    input.value = qty;
    updateCart(key, qty);
  });



  /* ============================================================
     📌 SMOOTH SCROLL + MOBILE MENU
  ============================================================ */
  // Resolve an href to an element. Handles Shopify's volatile section-wrapper ids
  // (#shopify-section-template--<num>__<key>) by falling back to the stable <key>,
  // so links keep working after the numeric prefix regenerates on a theme copy.
  function resolveTarget(href) {
    if (!href || href.charAt(0) !== "#") return null;
    let el = document.querySelector(href);
    if (el) return el;
    const m = href.match(/__([A-Za-z0-9_]+)$/);
    if (m) el = document.querySelector('[id^="shopify-section-"][id$="__' + m[1] + '"]');
    return el;
  }

  document.querySelectorAll('.kids-tab-btn, .kids-mobile-menu a').forEach(link => {
    link.addEventListener("click", (e) => {
      const href = link.getAttribute("href");
      if (href.startsWith("#")) {
        e.preventDefault();
        const target = resolveTarget(href);
        if (!target) return;

        window.scrollTo({
          top: target.offsetTop - 40,
          behavior: "smooth"
        });

        document.querySelector(".kids-mobile-menu")?.classList.remove("active");
      }
    });
  });

  const burger = document.querySelector(".kids-hamburger");
  const mobileMenu = document.querySelector(".kids-mobile-menu");

  if (burger && mobileMenu) {
    burger.addEventListener("click", () => {
      mobileMenu.classList.toggle("active");
    });
  }



  /* ============================================================
     🔍 SCROLL SPY
  ============================================================ */
  const sections = [
    '[id^="shopify-section-"][id$="__featured_product_BUEGLb"]',
    "#benefits",
    "#faq"
  ].map(id => document.querySelector(id));

  const navLinks = document.querySelectorAll(".kids-tab-btn");

  const activateLink = (el) => {
    navLinks.forEach(link => {
      link.classList.toggle("active", resolveTarget(link.getAttribute("href")) === el);
    });
  };

  window.addEventListener("scroll", () => {
    let scrollPos = window.scrollY + 150;

    sections.forEach(section => {
      if (!section) return;

      const top = section.offsetTop;
      const bottom = top + section.offsetHeight;

      if (scrollPos >= top && scrollPos <= bottom) {
        activateLink(section);
      }
    });
  });



  /* ============================================================
     ✨ IMAGE / SECTION REVEAL ANIMATIONS
  ============================================================ */

  // 1) Fullwidth image reveal
  const fullImg = document.querySelector('.fullwidth-image-wrap');
  if (fullImg) {
    const imgObserver = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            fullImg.classList.add('show');
          }
        });
      },
      { threshold: 0.2 }
    );
    imgObserver.observe(fullImg);
  }

  // 2) Transformation section reveal
  const transfSection = document.querySelector(".transformation-section");
  if (transfSection) {
    const transfObserver = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            transfSection.classList.add("in-view");
          }
        });
      },
      { threshold: 0.2 }
    );
    transfObserver.observe(transfSection);
  }

  /* ============================================================
     ✨ BENEFITS SECTION REVEAL
  ============================================================ */

  // 3) Benefits title reveal
  const benefitsTitle = document.querySelector(".benefits-title");
  if (benefitsTitle) {
    const benefitsTitleObserver = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            benefitsTitle.classList.add("in-view");
          }
        });
      },
      { threshold: 0.2 }
    );
    benefitsTitleObserver.observe(benefitsTitle);
  }

  // 4) Benefits section reveal
  const benefitsSection = document.querySelector(".benefits-section");
  if (benefitsSection) {
    const benefitsObserver = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            benefitsSection.classList.add("in-view");
          }
        });
      },
      { threshold: 0.2 }
    );
    benefitsObserver.observe(benefitsSection);
  }

    /* ============================================================
     ✨ BENEFITS 2 — TITLE + SECTION REVEAL
  ============================================================ */

  // 5) Benefits2 title reveal
  const benefits2Title = document.querySelector(".benefits2-title");
  if (benefits2Title) {
    const benefits2TitleObserver = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            benefits2Title.classList.add("in-view");
          }
        });
      },
      { threshold: 0.2 }
    );
    benefits2TitleObserver.observe(benefits2Title);
  }

  // 6) Benefits2 section reveal
  const benefits2Section = document.querySelector(".benefits2-section");
  if (benefits2Section) {
    const benefits2Observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            benefits2Section.classList.add("in-view");
          }
        });
      },
      { threshold: 0.2 }
    );
    benefits2Observer.observe(benefits2Section);
  }


  /* ============================================================
     ❓ FAQ SECTION REVEAL + ACCORDION
  ============================================================ */

  const faqSection = document.querySelector(".sk-faq-section");
  if (faqSection) {
    const faqObserver = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          faqSection.classList.add("visible");
        }
      });
    }, { threshold: 0.2 });
    faqObserver.observe(faqSection);
  }

  document.querySelectorAll(".sk-faq-question").forEach(btn => {
    btn.addEventListener("click", () => {
      const item = btn.parentElement;

      // Close all others
      document.querySelectorAll(".sk-faq-item").forEach(i => {
        if (i !== item) i.classList.remove("open");
      });

      item.classList.toggle("open");
    });
  });

});
